export interface ReportingDefaultsData {
  [key: string]: any;
}
export const LINK_POSITION_BODY = "Body";
export const ReportingDefaults: ReportingDefaultsData = {
  breadCrumbs: {
    contentFriendlyName: `breadCrumbs`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  carousel: {
    contentFriendlyName: `package card`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  faqPanel: {
    Infinity: {
      contentFriendlyName: `FAQ_PANEL`,
      contentProductGroup: ``,
      contentSystem: "AEM"
    }
  },
  gvpPanel: {
    Infinity: {
      contentFriendlyName: `GVP_Panel`,
      contentProductGroup: ``,
      contentSystem: "AEM"
    }
  },
  heroPanel: {
    Infinity: {
      contentFriendlyName: `Deals_Big_Brands_Bigger_Savings`,
      contentProductGroup: ``,
      contentSystem: "AEM"
    }
  },
  quizComponent: {
    Infinity: {
      contentFriendlyName: `Deals_Quiz_Form`,
      contentProductGroup: ``,
      contentSystem: "AEM"
    }
  },
  alert: {
    contentFriendlyName: `alertbanner`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  formBuilder: {
    contentFriendlyName: `formBuilder`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  cardgridlist: {
    contentFriendlyName: `package card`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  table: {
    contentFriendlyName: `table`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  canvas: {
    contentFriendlyName: `canvas`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  iframe: {
    contentFriendlyName: `iframe`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  channelsBoard: {
    contentFriendlyName: `channels board`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  floatingWidget: {
    Infinity: {
      contentFriendlyName: `floating widget`,
      contentProductGroup: ``,
      contentSystem: "AEM"
    }
  },
  dtvExternalScriptLoader: {
    contentFriendlyName: `dtv-external-script-loader`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  UcgGalleryLoader: {
    contentFriendlyName: `ucg-gallery-loader`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  PkgComparisonModalV2: {
    contentFriendlyName: `pkg-compare-modal-V2`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvLongFormatCard: {
    contentFriendlyName: `dtv-long-format-card`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  contentCard: {
    contentFriendlyName: `dtv-content-card`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvMarquee: {
    contentFriendlyName: `dtv-marquee`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  rotatingMarque: {
    contentFriendlyName: `rotating-marque`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvCountDown: {
    contentFriendlyName: `dtv-countDown`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  VideoMarqueeCampaign: {
    contentFriendlyName: `dtv-VideoMarqueeCampaign`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  exitModal: {
    contentFriendlyName: `dtv-exitModal`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvEntertainmentCarousel: {
    contentFriendlyName: `dtv-carousel`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvFindRetailer: {
    contentFriendlyName: `dtv-find-retailer`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  internalProductComparisionChart: {
    contentFriendlyName: `dtv-internal-product-comparision-chart`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvPageSectionHeader: {
    contentFriendlyName: `dtv-page-section-header`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvPlanCard: {
    contentFriendlyName: `dtv-page-plan-card`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvInPageLegal: {
    contentFriendlyName: `dtv-in-page-legal`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvVerticalSpacer: {
    contentFriendlyName: `dtv-vertical-spacer`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvHeadline: {
    contentFriendlyName: `dtv-headline`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvListItem: {
    contentFriendlyName: `dtv-list-item`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtv4UpIconListItem: {
    contentFriendlyName: `dtv-4up-icon-list-item`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvHero: {
    Infinity: {
      contentFriendlyName: `dtv-hero`,
      contentProductGroup: ``,
      contentSystem: "AEM"
    }
  },
  dtvMessagingBanner: {
    contentFriendlyName: `dtv-messaging-banner`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvMessagingCard: {
    contentFriendlyName: `dtv-messaging-card`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvMduHero: {
    contentFriendlyName: `dtv-mdu-hero`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvExternalServiceComparison: {
    contentFriendlyName: `dtv-external-service-comparison`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvExternalServiceComparisonChartTabs: {
    contentFriendlyName: `dtv-external-service-comparison-chart-tabs`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtv1Up2UpMedia: {
    Infinity: {
      contentFriendlyName: `dtv-1up-2up-media`,
      contentProductGroup: ``,
      contentSystem: "AEM"
    }
  },
  dtviframe: {
    contentFriendlyName: `dtviframe`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvLinkFarm: {
    contentFriendlyName: `dtv-linkfarm`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvAgnosticPlanCards: {
    Infinity: {
      contentFriendlyName: `dtv-agnostic-plancards`,
      contentProductGroup: ``,
      contentSystem: "AEM"
    }
  },
  insiderPanel: {
    Infinity: {
      contentFriendlyName: `INSIDER_PANEL`,
      contentProductGroup: ``,
      contentSystem: "AEM"
    }
  },
  channelLogoCarousal: {
    contentFriendlyName: `channel-logo-carousal`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvFirstName: {
    contentFriendlyName: `First Name`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  dtvThreeUp: {
    contentFriendlyName: `Three up component`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  PACKAGECOMPARISONCALCULATOR: {
    contentFriendlyName: `Package Comparision Savings Calculator`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  LOCALCHANNELSLOOKUPPAGE: {
    contentFriendlyName: `Local Channels Lookup Page`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  marketingBanner: {
    contentFriendlyName: `Marketing Banner`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  showCarousal: {
    contentFriendlyName: `Show Carousal`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  searchComponent: {
    ContentFriendlyName: `Search`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  searchWatchNow: {
    contentFriendlyName: `Search Watch Now`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  seoContent: {
    contentFriendlyName: `Seo Content`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  RsnLookupTool: {
    contentFriendlyName: `RSN Lookup Tool`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  },
  LocalRsnTool: {
    contentFriendlyName: `Local RSN Tool`,
    contentProductGroup: ``,
    contentSystem: "AEM"
  }
};
